import "keen-slider/keen-slider.min.css";
import KeenSlider from "keen-slider";

const heroBannerSlider = document.querySelector(".js-hero-banner__carousel");

if (heroBannerSlider && heroBannerSlider.childElementCount > 1) {
  let interval = 0;
  function autoplay(run) {
    clearInterval(interval);
    interval = setInterval(() => {
      if (run && slider) {
        slider.next();
      }
    }, 5000);
  }

  const slider = new KeenSlider(heroBannerSlider, {
    loop: true,
    duration: 1000,
    slidesPerView: 1,

    dragStart: () => {
      autoplay(false);
    },
    dragEnd: () => {
      autoplay(true);
    },
  });

  autoplay(true);

  heroBannerSlider.addEventListener("mouseover", () => {
    autoplay(false);
  });
  heroBannerSlider.addEventListener("mouseout", () => {
    autoplay(true);
  });
}
